/**
 * @generated SignedSource<<e338f07daf5f9ea1b4e5e9a009d8cff1>>
 * @relayHash 8633de924286a3b6cfa4bd8369e3c51a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 2f7542fcde8cd416f6124b7f20b64578f45611ba05de318953ff2301fbd7fd4a

import type { ConcreteRequest, Query } from 'relay-runtime';
export type JiraSprintState = "ACTIVE" | "CLOSED" | "FUTURE" | "%future added value";
export type getSprintProps_recentlyUsedSprintsQuery$variables = {
  cloudId: string;
};
export type getSprintProps_recentlyUsedSprintsQuery$data = {
  readonly jira: {
    readonly jqlBuilder: {
      readonly recentlyUsedSprints: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly displayName: string;
            readonly jqlTerm: string;
            readonly sprint: {
              readonly boardName: string | null | undefined;
              readonly state: JiraSprintState | null | undefined;
            };
          } | null | undefined;
        } | null | undefined> | null | undefined;
      } | null | undefined;
    } | null | undefined;
  };
};
export type getSprintProps_recentlyUsedSprintsQuery = {
  response: getSprintProps_recentlyUsedSprintsQuery$data;
  variables: getSprintProps_recentlyUsedSprintsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  }
],
v2 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 5
  }
],
v3 = {
  "kind": "ScalarField",
  "name": "jqlTerm"
},
v4 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v5 = {
  "kind": "ScalarField",
  "name": "state"
},
v6 = {
  "kind": "ScalarField",
  "name": "boardName"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "getSprintProps_recentlyUsedSprintsQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "concreteType": "JiraQuery",
          "kind": "LinkedField",
          "name": "jira",
          "plural": false,
          "selections": [
            {
              "args": (v1/*: any*/),
              "concreteType": "JiraJqlBuilder",
              "kind": "LinkedField",
              "name": "jqlBuilder",
              "plural": false,
              "selections": [
                {
                  "args": (v2/*: any*/),
                  "concreteType": "JiraJqlSprintFieldValueConnection",
                  "kind": "LinkedField",
                  "name": "recentlyUsedSprints",
                  "plural": false,
                  "selections": [
                    {
                      "concreteType": "JiraJqlSprintFieldValueEdge",
                      "kind": "LinkedField",
                      "name": "edges",
                      "plural": true,
                      "selections": [
                        {
                          "concreteType": "JiraJqlSprintFieldValue",
                          "kind": "LinkedField",
                          "name": "node",
                          "plural": false,
                          "selections": [
                            (v3/*: any*/),
                            (v4/*: any*/),
                            {
                              "concreteType": "JiraSprint",
                              "kind": "LinkedField",
                              "name": "sprint",
                              "plural": false,
                              "selections": [
                                (v5/*: any*/),
                                (v6/*: any*/)
                              ]
                            }
                          ]
                        }
                      ]
                    }
                  ],
                  "storageKey": "recentlyUsedSprints(first:5)"
                }
              ]
            }
          ]
        },
        "action": "THROW",
        "path": "jira"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "getSprintProps_recentlyUsedSprintsQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraJqlBuilder",
            "kind": "LinkedField",
            "name": "jqlBuilder",
            "plural": false,
            "selections": [
              {
                "args": (v2/*: any*/),
                "concreteType": "JiraJqlSprintFieldValueConnection",
                "kind": "LinkedField",
                "name": "recentlyUsedSprints",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraJqlSprintFieldValueEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "JiraJqlSprintFieldValue",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          (v4/*: any*/),
                          {
                            "concreteType": "JiraSprint",
                            "kind": "LinkedField",
                            "name": "sprint",
                            "plural": false,
                            "selections": [
                              (v5/*: any*/),
                              (v6/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "id"
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ],
                "storageKey": "recentlyUsedSprints(first:5)"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "2f7542fcde8cd416f6124b7f20b64578f45611ba05de318953ff2301fbd7fd4a",
    "metadata": {},
    "name": "getSprintProps_recentlyUsedSprintsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "4b4910b78913bf0c2ded783a356b9f91";

export default node;
